import BoxLoader from "../../../../general/boxLoader";
import React, {useEffect, useRef, useState} from "react";
import {useGetPatientBiometricChartsData} from "../../../../../../hook/request/ehr/patientBiometric";
import {useMySearchParams} from "../../../../../../hook/useMySearchParams";
import {useSearchParams} from "react-router-dom";
import {MtoJDateFormat} from "../../../../../../utils/date";
import {BIOMETRIC_TYPE} from "../../../../../../constants/constant/enum";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import {chartOptions} from "../../../../general/chartOptions";


type TFilterValues = {
  type?: number;
  patient?: string;
  pageNumber?: string;
  perPage?: string;
  search?: string;
  sort?: string;
}

type TChartProps = {
  patientId?: string;
  displayX?: boolean;
  displayY?: boolean;
  showLegend?: boolean;
  displayDataLabels?: boolean;
  showExportButton?: boolean
  openTab?: string;
}

const PatientHeightChart = ({
  patientId,
  displayX = true,
  displayY = true,
  showLegend = true,
  displayDataLabels = false,
  showExportButton = true,
  openTab,
}: TChartProps) => {

  const [searchParams] = useSearchParams();
  const { getQueryParams } = useMySearchParams();
  const [data, setData] = useState([]);
  const [labels, setLabels] = useState([]);
  const [filterValues, setFilterValues] = useState<TFilterValues>({
    type: BIOMETRIC_TYPE.HEIGHT.value,
    patient: patientId,
    pageNumber: "0",
    perPage: "10",
    search: "",
    sort: "asc",
  });

  //services
  const getBiometricChartsRequest = useGetPatientBiometricChartsData(getQueryParams(filterValues), openTab === 'height');

  useEffect(() => {
    let _filterValues = {};
    _filterValues = {
      ...filterValues,
      type: searchParams.get("type") || BIOMETRIC_TYPE.HEIGHT.value,
      patient: patientId,
      pageNumber: searchParams.get("pageNumber") || "0",
      perPage: searchParams.get("perPage") || "10",
      search: searchParams.get("search") || "",
      sort: searchParams.get("sort") || "asc",
    }
    setFilterValues(_filterValues)
  }, [searchParams]);

  useEffect(() => {
    if(!getBiometricChartsRequest.isPending && getBiometricChartsRequest?.data?.data?.result){
      const { data } = getBiometricChartsRequest?.data?.data?.result;
      let _heightData = [],
        _heightLabel = [];
      if(data){
        _heightData = data
          .map((item:any) => (item?.values[0]));
        _heightLabel = data
          .map((item:any) => (`${MtoJDateFormat(item?.label)}`));
      }

      setData(_heightData)
      setLabels(_heightLabel)

    }
  }, [getBiometricChartsRequest.data])

  const chartComponentRef = useRef<HighchartsReact.RefObject>(null);

  return (
    <div>
      {getBiometricChartsRequest.isPending ? <BoxLoader/> :
        <HighchartsReact
          highcharts={Highcharts}
          options={chartOptions({
            chartType: 'column',
            data: [data],
            dataNames: ['قد'],
            labels: labels,
            chartTitle: 'نمودار قد بیمار',
            displayXLabels: displayX,
            displayYLabels: displayY,
            displayDataLabels: displayDataLabels,
            showLegend: showLegend,
            showExportButton: showExportButton
          })} ref={chartComponentRef}
        />
      }
    </div>
  );
};

export default PatientHeightChart;